module.exports = __webpack_public_path__ + "76861fd8ad5f2a09aa04b2526077fb9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/swift-logo.png
// module id = 811
// module chunks = 0